import { Action, Reducer } from "redux";
import { clearDealerChanges, getDealSuccess } from "src/store/actions/deal";
import { pollingSuccess } from "src/store/actions/poller";
import { ActionType } from "src/store/dataService/actions/utils/actionCreator";

export interface DealerChangesState {
    changed: string[];
    added: string[];
}

const initialState = {
    changed: [],
    added: [],
};

type UpdateActions = ActionType<typeof pollingSuccess> | ActionType<typeof getDealSuccess>;

// TODO once we upgrade to typescript 4.1 add union type Action<`${string}/${"patch_vin" | "patch" | "put"}/request`>
type ClearActions = ActionType<typeof clearDealerChanges> | Action;

const dealerChanges: Reducer<DealerChangesState, UpdateActions | ClearActions> = (state = initialState, action) => {
    if (isUpdateAction(action)) {
        return {
            added: [
                ...state.added,
                ...(action.payload.deal?.dealer_changes
                    ?.filter(({ path }) => /^\/vehicles\/\w{17}$/.test(path))
                    .map(({ path }) => path.replace(/\/vehicles\//, "")) ?? []),
                ...Object.keys(
                    action.payload.deal?.dealer_changes?.find(({ path }) => /^\/vehicles$/.test(path))?.value ?? {}
                ),
            ],
            changed: [
                ...state.changed,
                ...(action.payload.deal?.dealer_changes
                    ?.filter(({ path }) => !/^\/vehicles\/\w{17}$/.test(path))
                    ?.map(({ path }) => path) ?? []),
            ],
        };
    }

    if (isClearAction(action)) {
        return {
            ...state,
            changed: [],
        };
    }

    return state;
};

export default dealerChanges;

function isUpdateAction(action: UpdateActions | ClearActions): action is UpdateActions {
    return action.type === pollingSuccess.type || action.type === getDealSuccess.type;
}

function isClearAction(action: UpdateActions | ClearActions): action is ClearActions {
    return action.type === clearDealerChanges.type || /\/patch|patch_vin|put\/request$/.test(action.type);
}
